import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const HomeWidgetService = {
  getList: async ({ isOnshore, widgetPageType = 9 }) => {
    console.log("🚀 ~ isOnshore:", isOnshore);
    try {
      const params = new URLSearchParams({
        ...(isOnshore !== null &&
          isOnshore !== undefined && { isOnshore: String(isOnshore) }),
        ...(widgetPageType !== null &&
          widgetPageType !== undefined && {
            widgetPageType: String(widgetPageType),
          }),
      });

      const response = await apiService.get(
        `/intelligent-portal/home-widgets?${params.toString()}`,
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/intelligent-portal/home-widgets/${id}`,
        updatedData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post(
      "/intelligent-portal/home-widgets",
      data,
    );
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(
      `/intelligent-portal/home-widgets/${id}`,
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/intelligent-portal/home-widgets/${id}`,
    );
    return response.data;
  },
};

export default HomeWidgetService;
